import { getQuotationCategory } from '@/api/quotation';

type ICategoryInfo = IQuotation.IResponse.ICategoryInfo;
export interface IManDayInfo {
  manDay: number;
  totalManDay: number;
}
interface ICategoryStore {
  [key: string]: ICategoryInfo;
}

let categoryIdForAdditional: string[] = [];
const categoryStore: ICategoryStore = {};

export let categorys: ICategoryInfo[] = [];

export const findCategoryById = (id: string): ICategoryInfo | undefined => {
  if (categoryStore[id]) {
    return categoryStore[id];
  }
  return categorys.find((category) => category.id === id);
};
export const findCategoryNameById = (id: string) => {
  const category = findCategoryById(id);
  if (category) {
    return category.name;
  }
  return id;
};

export const calculateManDay = (solution: ISolution.IResponse.ISolutionInfo): IManDayInfo => {
  let manDay = 0;
  let totalManDay = 0;
  solution.items.forEach((item) => {
    totalManDay += item.manDay;
    if (!categoryIdForAdditional.includes(item.categoryId)) {
      manDay += item.manDay;
    }
  });
  return {
    manDay: Number(manDay.toFixed(2)),
    totalManDay: Number(totalManDay.toFixed(2)),
  };
};

const filterAdditiona = (categoryInfos: ICategoryInfo[]) => {
  categoryIdForAdditional = [];
  categoryInfos.forEach((category) => {
    if (category.isAdditional) {
      categoryIdForAdditional.push(category.id);
    }
  });
};

export const requestGetQuotationCategorys = (
  params: IQuotation.IRequest.IGetCategory = {},
): Promise<string> => {
  return new Promise((reslove, reject) => {
    getQuotationCategory(params).then((res) => {
      categorys = res.data;
      filterAdditiona(res.data);
      reslove(res.message);
    }).catch((error) => {
      reject(error.message);
    });
  });
};
